/**
 * Picks the best human-facing string for alt text (marketing name before facet id).
 */
export function resolveCompanyLogoAltDisplayName(
  initialsSourceName?: string | null,
  companyName?: string | null,
  companyId?: string | null
): string {
  const fromInitials = (initialsSourceName ?? '').trim();
  if (fromInitials) return fromInitials;
  const fromName = (companyName ?? '').trim();
  if (fromName) return fromName;
  return (companyId ?? '').trim();
}
